import React from 'react';
import Btn from './btn';
import './exhibitorCard.css';
import Card from './card';
import diwanLogo from '../../assets/icons/diwanLogo.svg';
import locationIcon from '../../assets/icons/locationIcon.svg';
import ExhibitorCategory from './exhibitorCategory';


const ExhibitorCard = (props) => {
    return ( 
        <>
        <div className="exhibitorCard">
        <Card
  vendorCardStyle="card2"
  vendorLogo={props.exhibitorLogo || diwanLogo}
/>
            <div className="exhibitorCardDetails">
                <h4>{props.exhibitorName}</h4>
                <p>{props.exhibitorDesc}</p>
                <div className="exhibitorCategories">
                    <ExhibitorCategory exhibitorCategory={props.exhibitorCategory1} />
                    <ExhibitorCategory exhibitorCategory={props.exhibitorCategory2} />
                    <ExhibitorCategory exhibitorCategory={props.exhibitorCategory3} />
                </div>
                <div className="exhibitorLocation">
                    <img src={locationIcon} alt="location pin icon" />
                    <p>{props.exhibitorLocation}</p>
                </div>
                <Btn btnText="View Booth" btnStyle="exploreBtn" />
            </div>
        </div>
        </>
     );
}

export default ExhibitorCard;